module.exports = __webpack_public_path__ + "img/img.9ef2d456.png";